import ReceivePaymentDialog from './ReceivePaymentDialog.container';

export default ReceivePaymentDialog;
